import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import "./css/cityLanding.css"
import Succes1 from "./assets/Succes.svg"
import images from "./assets/images.png"
import Rating from '@material-ui/lab/Rating';
import { getHashtagsList, createRatingByUser } from "./redux/landingCrud"
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

const Container = styled.div`
  width: 100% !important;
  min-height: 300px;
  height: auto;
  margin: 0;
  justify-content: center;
  align-items: center;
`;


const Title = styled.p`
  font-weight: bold;
  display:block;
  text-align:center;
  font-size: 21px;
`;

const Text = styled.p`
  display:block;
  text-align:center;
  font-size: 16px;
`;

const Icon = styled.div`
  text-align:center;
//   background-color: #6dd06d;
//   color: #fff;
  border-radius: 20px;
  min-height:45px;
  display:flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const Item = styled.div`
  text-align:center;
  background-color: #fff;
    border-radius: 20px;
    // box-shadow: 0 4px 7px -6px #222;
  min-height:45px;
  display:flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ccc;
  cursor: pointer;
`;

const TextSize = styled.div`
  text-align:center;
  font-weight: bold;
   font-size: 26px;
  @media only screen and (max-width: 600px) {
    font-size: 19px;
  }
`;

const Button = styled.button`
  background-color: #ccc;
  border-radius: 20px;
  width: 140px;
  padding: 10px;
  border: none;
  color: white;
`;

const Submit = styled.button`
//   background-color: linear-gradient(180deg, #F7B61D, #F7941D);
    background-color:#6dd06d;
  border-radius: 20px;
  width: 120px;
  padding: 10px;
  border: none;
  color: white;
  min-height:45px;
`;

const Direction = styled.span`
    font-size: 14px !important;
    background-color: #fff;
    border-radius: 15px;
    box-shadow: 0 4px 7px -6px #222;
`;


function PassengerRate() {
    const [comment, setComment] = useState("")
    const [submitOpen, setSubmitOpen] = useState(false)
    const [star, setStar] = React.useState(3);
    const [clickPositive, setClickPositive] = React.useState(true);
    const [clickNegative, setClickNegative] = React.useState(false);
    const [clickItem, setClickItem] = React.useState(false);
    const [itemsId, setItemsId] = React.useState([]);
    const [itemsIdNegative, setItemsIdNegative] = React.useState([]);
    const [item, setItem] = React.useState([]);
    const [travelId, setTravelId] = React.useState(null);
    const [phone, setPhone] = React.useState(null);
    const [itemsPositive, setItemsPositive] = React.useState([]);
    const [itemsNegative, setItemsNegative] = React.useState([]);
    const [error, setError] = React.useState(null);
    const [errorNotFound, setErrorNotFound] = React.useState({});

    const myRef = useRef(null)
    const { user } = useSelector((state) => state.auth);

    const history = useHistory().location.pathname.split("/");

    const handleClickItemsPositive = (event, index) => {
        var tempArray = itemsId
        if (tempArray.indexOf(index) !== -1) {
            tempArray.splice(tempArray.indexOf(index), 1);
        }
        else {
            tempArray.push(index)
        }
        setItemsIdNegative(tempArray)
        setItemsId(tempArray)

    };

    const handleClickItemsNegative = (event, index) => {
        var tempArray = itemsIdNegative
        if (tempArray.indexOf(index) !== -1) {
            tempArray.splice(tempArray.indexOf(index), 1);
        }
        else {
            tempArray.push(index)
        }
        setItemsIdNegative(tempArray)
        setItemsId(tempArray)
    };

    useEffect(() => {
        const url = history[2]
        getHashtagsList(url)
            .then((res) => {
                setItemsPositive(res.data.positive)
                setTravelId(res.data.travelId)
                setPhone(res.data.phone)
            })
            .catch((err) => {
                setSubmitOpen(true)
                setErrorNotFound({ text: `${err.response.data.message}`, img: images })
                console.log("eee", err.response.data.message)
            })
    }, [item]);

    return (<>
        {submitOpen ?
            <div className="container d-flex justify-content-center align-items-center mt-30">
                <div className="d-flex justify-content-center align-items-center mt-15 p-5 row bg-white px-10 col-12" ref={myRef} style={{ boxShadow: "rgb(0 0 0 / 10%) 0px 0px 10px 0px" }}>
                    <img src={errorNotFound.img} style={{ width: "100px" }} alt="succes"></img>
                    <TextSize className="col-12 d-flex justify-content-center mt-5 px-0">
                        <p className="mb-0">{errorNotFound.text}</p>
                    </TextSize>
                    <div className="col-12 d-flex justify-content-center mt-8">
                        <Button
                            className="col-12 col-md-5 my-2 p-5 "
                            style={{ backgroundColor: "#3DC36D", borderRadius: "15px", fontSize: "large" }}
                        >
                            <a href="http://ebus.ir"> <span className="mx-auto my-auto text-white">بازگشت به صفحه اصلی </span></a>
                        </Button>
                    </div>
                </div>
            </div>
            :
            <>
                <div className="container px-xl-40">
                    <Container>
                        <div className='row d-flex justify-content-center'>
                            <div className="mt-10 col-12">
                                <Title >امتیاز به سفر</Title>
                                <Text className="col-12">به سفر خود امتیاز دهید</Text>
                            </div>
                            <div className="col-12 d-flex justify-content-center">
                                <Rating
                                    style={{ color: "#ffb400", fontSize: "5rem" }}
                                    name="simple-controlled"
                                    size="large"
                                    value={star}
                                    onChange={(event, newValue) => {
                                        setStar(newValue);
                                    }}
                                />
                            </div>
                            <Direction className="col-12 col-md-9 mt-10 mb-3 row py-2 d-flex justify-content-center">
                                <Icon
                                    className="col-6"
                                    style={{
                                        backgroundColor: clickPositive ? "#6dd06d" : "#fff",
                                        color: clickPositive ? "#fff" : "#000"
                                    }}
                                    onClick={() => {
                                        setClickPositive(true)
                                        setClickNegative(false)
                                        getHashtagsList(history[2])
                                            .then((res) => {
                                                setItemsPositive(res.data.positive)
                                            });
                                        setItemsNegative(null)
                                    }}
                                >
                                    نقاط قوت
                                </Icon>
                                <Icon
                                    className="col-6"
                                    style={{
                                        backgroundColor: clickNegative ? "rgb(253, 161, 161)" : "#fff",
                                        color: clickNegative ? "#fff" : "#000"
                                    }}
                                    onClick={() => {
                                        setClickNegative(true)
                                        setClickPositive(false)
                                        getHashtagsList(history[2])
                                            .then((res) => {
                                                setItemsNegative(res.data.negative)
                                            });
                                        setItemsPositive(null)
                                    }}
                                >
                                    نقاط ضعف
                                </Icon>
                            </Direction>

                            <div className="row d-flex justify-content-between col-12 col-md-9 mt-5">
                                {itemsPositive ? itemsPositive.map((item) => {
                                    return (
                                        <Item
                                            key={item.id}
                                            className="col-5 mt-3"
                                            style={{
                                                backgroundColor: itemsId?.indexOf(item.id) > -1 ? "rgb(146 245 146)" : "#fff",
                                                border: itemsId?.indexOf(item.id) > -1 ? "1px solid #6dd06d" : "1px solid #ccc",
                                                color: itemsId?.indexOf(item.id) > -1 ? "#000" : "#aaa",
                                            }}
                                            onClick={(e) => {
                                                handleClickItemsPositive(e, item.id)
                                            }}
                                        >
                                            {item.name}
                                        </Item>
                                    )
                                }) :
                                    null}
                            </div>

                            <div className="row d-flex justify-content-between col-12 col-md-9 ">
                                {itemsNegative ? itemsNegative.map((item) => {
                                    return (
                                        <Item
                                            key={item.id}
                                            className="col-5 mt-3"
                                            style={{
                                                backgroundColor: itemsIdNegative?.indexOf(item.id) > -1 ? "#fda1a1" : "#fff",
                                                border: itemsIdNegative?.indexOf(item.id) > -1 ? "1px solid #f94848" : "1px solid #ccc",
                                                color: itemsIdNegative?.indexOf(item.id) > -1 ? "#000" : "#aaa",
                                            }}
                                            onClick={(e) => {
                                                handleClickItemsNegative(e, item.id)
                                            }}
                                        >
                                            {item.name}
                                        </Item>
                                    )
                                }) :
                                    null}
                            </div>
                            <textArea
                                className="mt-md-20 mt-10  col-12 col-md-9 p-5"
                                type="text"
                                placeholder="میخواهم نظر خود را بنویسم"
                                value={comment}
                                onChange={(e) => { setComment(e.target.value) }}
                                style={{ minHeight: "100px", borderRadius: "10px", outline: "none", border: "#ddd solid 1px" }} />
                            <div className="row d-flex justify-content-right col-12 col-md-9">
                                <Submit
                                    className="col-6 col-md-4 mt-3"
                                    onClick={() => {
                                        var value = {}
                                        value.travelId = travelId
                                        value.hashtags = itemsId
                                        value.star = star
                                        value.comment = comment
                                        value.phone = phone
                                        value.url = history[2]
                                        console.log("value", value)
                                        if (user) {
                                            createRatingByUser(value, user.token)
                                                .then((res) => {
                                                    console.log("res", res.data)
                                                    setComment("")
                                                    setSubmitOpen(true)
                                                    setErrorNotFound({ text: "نظر شما با موفقیت ثبت شد", img: Succes1 })
                                                    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
                                                })
                                                .catch((err) => {
                                                    if (err.response.status === 403) {
                                                        toast.error("شما قبلا نظر خود را ثبت کرده اید.")
                                                        setError("شما قبلا نظر خود را ثبت کرده اید.")
                                                    }
                                                    else if (err.response.status === 404) {
                                                        toast.error("مدت زمان ارسال نظر برای این سفر به اتمام رسیده است")
                                                        setError("مدت زمان ارسال نظر برای این سفر به اتمام رسیده است")
                                                    }
                                                    else if (err.response.status === 422) {
                                                        console.log(err.response.data.error, "errrr")
                                                        toast.error("مشکلی در ارتباط با سرور به وجود آمد")
                                                    }
                                                    else {
                                                        toast.error("مشکلی در ارتباط با سرور به وجود آمد")
                                                        setError("مشکلی در ارتباط با سرور به وجود آمد")
                                                    }

                                                })

                                        }
                                        else {
                                            createRatingByUser(value)
                                                .then((res) => {
                                                    console.log("resss2", res.data)
                                                    setComment("")
                                                    setSubmitOpen(true)
                                                    setErrorNotFound({ text: "نظر شما با موفقیت ثبت شد", img: Succes1 })
                                                    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
                                                })
                                                .catch((err) => {
                                                    if (err.response.status === 403) {
                                                        toast.error("شما قبلا نظر خود را ثبت کرده اید.")
                                                        setError("شما قبلا نظر خود را ثبت کرده اید.")
                                                    }
                                                    else if (err.response.status === 404) {
                                                        toast.error("مدت زمان ارسال نظر برای این سفر به اتمام رسیده است")
                                                        setError("مدت زمان ارسال نظر برای این سفر به اتمام رسیده است")
                                                    }
                                                    else if (err.response.status === 422) {
                                                        console.log(err.response.data.error, "errrr")
                                                        toast.error("مشکلی در ارتباط با سرور به وجود آمد")
                                                    }
                                                    else {
                                                        toast.error("مشکلی در ارتباط با سرور به وجود آمد")
                                                        setError("مشکلی در ارتباط با سرور به وجود آمد")
                                                    }

                                                })
                                        }

                                    }}
                                >ثبت نظر
                                </Submit>

                            </div>
                            <b className="row form-group text-danger pl-5 mt-5 col-12 col-md-9">{error ? error : null}</b>
                        </div>

                    </Container>

                </div>
            </>
        }
    </>
    )
}

export default PassengerRate